import {flare} from "@flareapp/flare-client";

// bootstrap - You can specify which plugins you need
import { Offcanvas, Tab, Modal, Collapse } from 'bootstrap';

// Only enable Flare in production, we don't want to waste your quota while you're developing:
if (process.env.NODE_ENV === 'production') {
    flare.light('RRmXISHWdqUMXQq3k6SUnV13DvBJnLl9');
}

// init Swiper
// import Swiper from 'swiper';
// import 'swiper/css/bundle';

import currencyAPI from "./modules/currency.js";
import accordion from "./modules/accordion.js";
import slidermanager from "./modules/slider.js";
import navmanager from "./modules/nav.js";
import mobilemenu from "./modules/mobilemenu";
import savebasket from "./modules/savebasket";
import studcalculator from "./modules/studcalculator";
import cookieConsent from "./modules/cookie-consent";
import knowledgebase from "./modules/knowledge-base";
import prodFilters from "./modules/prod-filters";
import minibasket from "./modules/mini-basket";

//import model from "./modules/models.js";
//import plusminus from "./modules/plus-minus-qunatity.js";

document.addEventListener("DOMContentLoaded", function () {
    var studslider = document.getElementById("stud-slider");
    if (studslider) {
        slidermanager.slider();
    }
    prodFilters.hideEmptyFilters();
});


const init = function () {
    accordion.accordionToggle();
    navmanager.stickyNavScroll();
    navmanager.observers();
    navmanager.searchtoggle();
    mobilemenu.addEvents();
    savebasket.init();
    studcalculator.init();
    minibasket.init();
    //filterProducts.categoryFilter();
    // model.modelToggle();
    currencyAPI.fetchAPI();
    knowledgebase.init();
    //cookieConsent();
}

jQuery(function ($) {
    $('button[name="update_cart"]', 'form.woocommerce-cart-form').removeAttr('disabled');
    $(document.body).on('updated_cart_totals', function () {
        $("form.woocommerce-cart-form:not(:first)", "section.cart-desktop").remove();
        $("form.woocommerce-cart-form:not(:first)", "section.cart-mobile").remove();
        $("div.cart_totals:not(:first)", "div.cart-collaterals").remove();
        $('button[name="update_cart"]', 'form.woocommerce-cart-form').removeAttr('disabled');
        //location.reload();
    });

// Function to handle mutations
    function handleMutations(mutationsList) {
        $('.purchase-options .price').html($('.woocommerce-variation-price span.price').html());

        // Check if del element in price
        if ($('.purchase-options .price del').length == 0 && $('.purchase-options .price span.vat').length == 0) {
            $('.purchase-options .price').append('<span class="vat">ex. VAT</span>');
        } else if ($('.purchase-options .price span.price del').length > 0) {
            $('.purchase-options .price span.vat').remove();
        }
    }

    var targetNode = document.querySelector(".single_variation_wrap");
    if (targetNode) {
        var observer = new MutationObserver(handleMutations);
        var config = {subtree: true, childList: true};
        observer.observe(targetNode, config);
    }
});

var loading = true;
window.onload = function () {
    if (loading) {
        init();
        loading = false;
    }
};
